import React from 'react';
import { GetShipment } from '../../../models/home/GetShipment.model';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { IONICWrapper, isEntitled } from '../../../utils/common';
import { EXECUTIONSTATUS, MODULES } from '../../../utils/constants';
import i18n from '../../../../i18n';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { IonGrid } from "@ionic/react";
import { Search } from "../../../models/home/Search.model";
import { Isearch } from "../../../schemas/Search/Search.schema";
import { getFormatRoles } from "../../../utils/formatData";
import { dayjs } from '../../../utils/Date/DateUtil';
import { IUserDetails } from '../../../schemas/user';

/**
 * based on the page and role it will return the count text.
*/
export const TextToDisplay = (actualData: any, subModule: string) => {
  return (
    <>
      {actualData && actualData.length}
      {isEntitled('myLoad', 'driverLoads') ? (
        <>
          {subModule === 'MyLoad/DriverAssigned' ? (
            <> {i18n.t('Assigned')}</>
          ) : (
            <>
              {subModule === 'MyLoad/InTransit' ? (
                <> {i18n.t('In-Transit')}</>
              ) : (
                <>
                  {' '}
                  {actualData &&
                    actualData.length <= 1
                    ? <>{i18n.t('Load')}</>
                    : <>{i18n.t('Loads')}</>}
                </>
              )}
            </>
          )}
        </>
      ) : (
        <> {i18n.t('Assigned')}</>
      )}
    </>
  )
}

/**
 * based on the user role it will set location value
*/
const startTripOk = async (data: any, props: any) => {
  const DriverAssignedStartTrip = props.subModule;
  const selectedLoad = data;
  let isUserCarrierDriver = false;
  let isGPStrackingDisabled = false;
  await IONICWrapper.details.auth.user.roles.forEach(
    async (role: any, count: any) => {
      if (role === 'carrierDriver') {
        isUserCarrierDriver = true;
      }
    }
  );
  if (!isUserCarrierDriver) {
    isGPStrackingDisabled = true;
  }
  props.setShipmentForStartTrip(selectedLoad);
  props.history.push({
    pathname: `/app/MyLoad/shipmentUpdateScreen/${selectedLoad.shipmentId}`,
    state: {
      isCurrentLocationOn: isGPStrackingDisabled,
      isLocation: false,
      module: DriverAssignedStartTrip,
      withGPS: true,
      startTripShipment: selectedLoad,
      moduleName: 'INTRANSIT'
    }
  })
};

/*
 * fetch the all shipment details while hitting the load for load details or execution page
 * @data - existing shipment details
 */
export const getShipmentDetails = (data: any, props: any,isGlobalSearch?:boolean): any => {
  const shipmentId = (data && data.shipmentId) || '';
  const getShipmentmodel: GetShipment = new GetShipment();
  const module = props.subModule;
  getShipmentmodel.shipmentIds = shipmentId;
  props.buyLoadShipmentRequest({
    query: getShipmentmodel.getRequestShipmentPayload(),
    shipmentId,
    module,
    isPullToRefresh: false,
    isGlobalSearch:isGlobalSearch
  });
  if (
    props.subModule === MODULES.INTRANSIT_MODULE ||
    (data && data.executionStatus === EXECUTIONSTATUS.STARTED) ||
    props.subModule === MODULES.RECENTLY_DELIVERED_MODULE ||
    props.subModule === MODULES.DELIVERED_WITH_PPWK_MODULE
  ) {
    startTripOk(data, props);
  } else {
    props.history.push(`/app/${props.subModule}/${shipmentId}`);
  }
  props.clearUpdateStopInfo();
};

/**
 * Send Analytics Event base on screen
 * * @param {*} pageName, carrierId
 * @returns null.
 */
export const sendAnalyticsEvent = (pageName: string, carrierId: any) => {
  let event: string;
  let screen: string;
  let event1 = '';
  let screen1 = '';
  switch (pageName) {
    case MODULES.CARRIER_ASSIGNED_MODULE:
      event = EVENT.SV_VIEW_CARRIER_ASSIGNED;
      screen = SCREEN.MYLOADS_CARRIER_ASSIGNED;
      break;
    case MODULES.DRIVER_ASSIGNED_MODULE:
      event = EVENT.SV_ASSIGN_DRIVER;
      screen = SCREEN.MYLOADS_DRIVER_ASSIGNMENT;
      event1 = EVENT.SV_VIEW_DRIVER_ASSIGNED;
      screen1 = SCREEN.MYLOADS_DRIVER_ASSIGNED;
      break;
    case MODULES.INTRANSIT_MODULE:
      event = EVENT.SV_VIEW_IN_TRANSIT;
      screen = SCREEN.MYLOADS_IN_TRANSIT;
      break;
    case MODULES.RECENTLY_DELIVERED_MODULE:
      event = EVENT.SV_VIEW_RECENTLY_DEL;
      screen = SCREEN.MYLOADS_RECENTLY_DELIVERED;
      break;
    case MODULES.RECENTLY_DELIVERED_MODULE:
      event = EVENT.SV_VIEW_RECENTLY_DEL;
      screen = SCREEN.MYLOADS_DELIVERED_NEEDS_PPWK;
      break;
    case MODULES.DELIVERED_WITH_PPWK_MODULE:
      event = EVENT.SV_VIEW_RECENTLY_DEL;
      screen = SCREEN.MYLOADS_DELIVERED_WITH_PPWK;
      break;
    default:
      return;
  }
  setScreenName(screen);
  logEvent(event, {
    screen,
    carrierId
  });

  if (event1 !== '') {
    setScreenName(screen1);
    logEvent(event1, {
      screen: screen1,
      carrierId
    });
  }
};

/**
 * Based on the driverAssignment status it will return the driver name
*/
export const getDriverName = (module: string, loadDetails: any) => {
  let driverName: any = "";
  if (
    module !== MODULES.DRIVER_ASSIGNED_MODULE ||
    (module === MODULES.DRIVER_ASSIGNED_MODULE &&
      loadDetails && loadDetails.driverAssignmentStatus === true)
  ) {
    driverName =
    loadDetails?.shipmentInvolvedParties?.filter((data: any) => {
        return data.partyType === "PRIMARY DRIVER";
      });
    driverName =
      driverName && driverName.length ? driverName[0].partyName : "";
  }

  if (
    loadDetails && loadDetails.driverAssignmentStatus === false &&
    module === MODULES.DRIVER_ASSIGNED_MODULE
  ) {
    driverName =
    loadDetails?.assignmentTransaction &&
      loadDetails.assignmentTransaction[0] &&
      loadDetails.assignmentTransaction[0].driverName;
  }
  return driverName;
}

export const getDriverAvatar = (props:
  {
    module: string,
    shipmentDetails: any
  }, className?: string,) => {
  let name = "";
  const driverName = getDriverName(props.module, props.shipmentDetails);

  if (driverName) {
    const fName = driverName.slice(0, 1);
    const LName = driverName.includes(" ")
      ? driverName.slice(
        driverName.indexOf(" ") + 1,
        driverName.indexOf(" ") + 2
      )
      : "";
    name = fName.toUpperCase() + LName.toUpperCase();
  } else {
    name = "U";
  }
  return <IonGrid className={className ? className : "driver-name-div"} data-test="driver-avatar">{name}</IonGrid>
}


export const getReloadShipmentDetails = (shipmentData: any, userDetails: IUserDetails, offSetValues: {
  destinationDateDefaultOffset: string,
  originDateDefaultOffset: string
}) => {
  const { shipment = {} } = shipmentData.assignDriverToShipment || {}
  const userRole = getFormatRoles();
  const destinationData = shipment && shipment.loadStop.filter((stop: any) => stop.stopType === "D")[0]
  const reloadDates = getReloadFromToDate(destinationData, offSetValues)

  const model: Search = new Search();
  model.originCity = destinationData.city;
  model.originState = destinationData.state;
  model.originCountry = destinationData.country;
  model.originPostalCode = destinationData.postalCode;
  model.originRadius = 100;
  model.pickUpStartDate = reloadDates.originFromDate;
  model.pickUpEndDate = reloadDates.originToDate;
  model.destinationCity = "Anywhere";
  model.destinationStates = [];
  model.destinationRadius = 100;
  model.dropStartDate ="" ;
  model.dropEndDate = "";
  model.destinationCountry = "";
  model.destinationPostalCode = ""
  model.trailerType = shipment.transportMode || "";
  model.size = 25;
  model.page = 0;
  model.sortColumn = "pickUpStartDate";
  model.sortDirection = "asc"
  model.userId = (userDetails?.memberDetailsResponse?.member?.upn) || "";
  model.carrierId = (userDetails?.memberDetailsResponse?.member?.carrierId) || "";
  model.carrierScac = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
  model.carrierTier = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
  model.managedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) || "";
  model.nonManagedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) || "";
  model.userRole = userRole.join(",");

  return model.getRequestPayload()
}

const getReloadFromToDate = (data: any, offSetValues: {
  destinationDateDefaultOffset: string,
  originDateDefaultOffset: string
}) => {


  if (new Date(data?.appointmentEarlyDateTime || data?.plannedDepartureDateTime) <= new Date()) {
    return {
      originFromDate: dayjs().format(),
      originToDate: dayjs(new Date().setDate(new Date().getDate() + parseInt(offSetValues.originDateDefaultOffset || "3"))).format(),
      destinationFromDate: dayjs().format(),
      destinationToDate: dayjs(new Date().setDate(new Date().getDate() + parseInt(offSetValues.destinationDateDefaultOffset || '9'))).format()
    }
  } else {
    const toDate = new Date(data?.appointmentEarlyDateTime || data?.plannedDepartureDateTime)
    return {
      originFromDate: data?.appointmentEarlyDateTime || data?.plannedDepartureDateTime,
      originToDate: dayjs(toDate.setDate(toDate.getDate() + parseInt(offSetValues.originDateDefaultOffset || "3"))).format(),
      destinationFromDate: dayjs().format(),
      destinationToDate: dayjs(new Date().setDate(new Date().getDate() + parseInt(offSetValues.destinationDateDefaultOffset || '9'))).format()
    }
  }
}

export const constructSearchParams = ({ assignDriverToShipment = {} }: any, offSetValues: any) => {
  const { shipment } = assignDriverToShipment;

  const destinationData = shipment && shipment.loadStop.filter((stop: any) => stop.stopType === "D")[0]

  const reloadDates = getReloadFromToDate(destinationData, offSetValues)

  const searchParams: Isearch = {
    origin: destinationData?.city,
    originCountry: destinationData?.country,
    originState: destinationData?.state,
    originPostalCode: destinationData?.postalCode,
    originRadius: 100,
    destination: "Anywhere",
    destinationStates: [],
    destinationCountry: "USA",
    destinationRadius: 100,
    TrailerType: shipment?.transportMode || "Dry van",
    dropStartDate: reloadDates?.destinationFromDate,
    dropEndDate: reloadDates?.destinationToDate,
    pickUpEndDate:
      reloadDates?.originToDate,
    pickUpStartDate:
      reloadDates?.originFromDate
  }
  return searchParams
}

export const getDestinationCityState = (shipmentData: any = {}) => {
  const shipment = shipmentData && shipmentData.assignDriverToShipment ? shipmentData.assignDriverToShipment.shipment : {};
  const destinationData = shipment && shipment.loadStop ? shipment.loadStop.filter((stop: any) => stop.stopType === "D")[0] : {}
  return { city: destinationData?.city || "", state: destinationData?.state || "" }
}

export const getPredecessorShipmentStatus = (shipment: any) => {
  return ["IN_TRANSIT", "DELIVERED", "COMPLETED", "CANCELLED"].includes(shipment.executionStatus)
}

export const constructSearchParamsAfterBookLoad = (shipment:any, offSetValues: any) => {
  const destinationData = shipment && shipment?.loadStop?.filter((stop: any) => stop.stopType === "D")[0]

  const reloadDates = getReloadFromToDate(destinationData, offSetValues)

  const searchParams: Isearch = {
    origin: destinationData?.city,
    originCountry: destinationData?.country,
    originState: destinationData?.state,
    originPostalCode: destinationData?.postalCode,
    originRadius: 100,
    destination: "Anywhere",
    destinationStates: [],
    destinationCountry: "USA",
    destinationRadius: 100,
    TrailerType: shipment?.transportMode || "Dry van",
    dropStartDate: reloadDates?.destinationFromDate,
    dropEndDate: reloadDates?.destinationToDate,
    pickUpEndDate:
      reloadDates?.originToDate,
    pickUpStartDate:
      reloadDates?.originFromDate
  }
  return searchParams
}